import { createSlice } from "@reduxjs/toolkit";
import { convertArrayToObject } from "../../helpers/catalog-helper";
import { userNormalLogout, supportLogout } from "../actions";

export interface BrandsState {
  brandsData: {};
}

const initialState: BrandsState = {
  brandsData: {},
};

export const brandsSlice = createSlice({
  name: "brands",
  initialState,
  reducers: {
    getAllBrandsData: (state) => {},
    saveAllBrandData: (state, actions) => {
      state.brandsData = actions.payload
        ? convertArrayToObject(actions.payload, "mid")
        : {};
    },
    deleteBrandData: (state, actions) => {},
    saveBrandData: (state, actions) => {},
  },
  extraReducers: (builder) => {
    builder
      .addCase(userNormalLogout, () => initialState)
      .addCase(supportLogout, () => initialState);
  },
});

export const {
  getAllBrandsData,
  saveAllBrandData,
  deleteBrandData,
  saveBrandData,
} = brandsSlice.actions;
export default brandsSlice.reducer;
